import { Action, createReducer, on } from '@ngrx/store';
import { ConnectionProfilesActions } from './connection-profiles.actions';

export const STORE_FEATURE_KEY_CONNECTION_PROFILES = 'connectionProfiles';

export class ConnectionProfileState {
    loading: boolean;
    connectionProfiles: Array<any>;
    isUpdated: boolean;
}

export const initializeConnectionProfileState: ConnectionProfileState = {
    connectionProfiles: [],
    loading: false,
    isUpdated: false
};

const reducer = createReducer(
    initializeConnectionProfileState,
    on(ConnectionProfilesActions.getConnectionProfilesSuccess, (state, { connectionProfiles }) =>
        ({ ...state,
           loading: false,
           connectionProfiles: connectionProfiles.map(connectionProfile => {
                const profile: any = {...connectionProfile};
                profile.profileDetailsJSON = JSON.parse(connectionProfile.profileDetailsJSON);

                return profile;
            })
        })),
    on(ConnectionProfilesActions.getConnectionProfiles, (state,  payload) =>
        ({ ...state,
           loading: true
        })),
    on(ConnectionProfilesActions.getConnectionProfilesFail, (state,  payload) =>
        ({ ...state,
           loading: false
        })),
    on(ConnectionProfilesActions.updateConnectionProfilesSuccess, (state, payload) =>
        ({ ...state,
           isUpdated: true
        })),
    on(ConnectionProfilesActions.updateConnectionProfiles, (state,  payload) =>
        ({ ...state,
           isUpdated: false
        })),
    on(ConnectionProfilesActions.updateConnectionProfilesFail, (state,  payload) =>
        ({ ...state,
           isUpdated: false
        }))

);

export function ConnectionProfilesReducer(state: ConnectionProfileState | undefined, action: Action) {
    return reducer(state, action);
}
